import { config } from '../config/config';

export type ScreenerStock = {
  symbol: string;
  companyName: string;
  marketCap: number | null;
  price: number | null;
  beta: number | null;
  volume: number | null;
  lastAnnualDividend: number | null;
  sector: string;
  industry: string;
  exchangeShortName: string;
  country: string;
  isEtf: boolean;
  isFund: boolean;
  isActivelyTrading: boolean;
  garPProxyScore: number;
  valueProxyScore: number;
  roicPct?: number | null;
  fetchedAtUtc: string;

  // Optional advanced metrics. When backend starts enriching these,
  // the GARP filter panel can use them immediately.
  revenueGrowthPct?: number | null;
  epsGrowthPct?: number | null;
  operatingIncomeGrowthPct?: number | null;
  peg?: number | null;
  operatingMarginTrendPct?: number | null;
  debtToEquity?: number | null;
  debtToEbitda?: number | null;
};

export type ScreenerResponse = { stocks: ScreenerStock[]; count: number; lastUpdatedUtc: string | null };

export async function fetchScreenerStocks(token: string): Promise<ScreenerResponse> {
  const response = await fetch(`${config.backend.baseUrl}/screener/stocks`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error(`Screener request failed (${response.status})`);
  return response.json();
}